import * as React from 'react'
import { QueryClientProvider } from 'react-query'
import { queryClient } from './lib/reactQueryClient'
import PropTypes from 'prop-types'

/**
 * AppProvider Component
 *
 * A higher-order component that provides context for React Query and handles suspense for loading states.
 *
 * @module AppProvider
 * @description A higher-order component that provides context for React Query and handles suspense for loading states.
 * @example
 * return (
 *   <AppProvider>
 *     <App />
 *   </AppProvider>
 * );
 *
 * @param {React.ReactNode} children - The child components to be rendered within the context of React Query.
 *
 * @returns {React.Element} A React component that wraps its children with the React Query provider and suspense fallback.
 */
export const AppProvider = ({ children }) => {
  return (
    <React.Suspense fallback={<div id="global-loader">LOADING.........</div>}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </React.Suspense>
  )
}

AppProvider.propTypes = {
  children: PropTypes.node.isRequired,
}
